export interface EventType {
  slug: string;
  name: string;
  date: string;
  time: string;
  venue: {
    name: string;
    address: string;
    mapUrl: string;
  };
  description: string;
  rsvpDeadline: string;
  imageUrl: string;
}

export const events: EventType[] = [
  {
    slug: "mehendi",
    name: "Mehendi Ceremony",
    date: "October 25, 2024",
    time: "5:00 PM onwards",
    venue: {
      name: "The Grand Ballroom",
      address: "123 Luxury Ave, Celebration City",
      mapUrl: "https://maps.google.com/?q=Starlight+Banquet",
    },
    description:
      "Join us for an evening of henna, music, and dance as we kick off the wedding festivities.",
    rsvpDeadline: "October 1, 2024",
    imageUrl: "/assets/images/about_me.jpg",
  },
  {
    slug: "sangeet",
    name: "Sangeet Night",
    date: "October 25, 2024",
    time: "7:00 PM onwards",
    venue: {
      name: "Starlight Banquet",
      address: "456 Celebration St, Los Angeles, CA 90001",
      mapUrl: "https://maps.google.com/?q=Starlight+Banquet",
    },
    description: "A night of music, dance, and joy. Come celebrate with us!",
    rsvpDeadline: "October 15, 2024",
    imageUrl: "/assets/images/about_me.jpg",
  },
  {
    slug: "wedding-ceremony",
    name: "Wedding Ceremony",
    date: "October 26, 2024",
    time: "11:00 AM - 1:00 PM",
    venue: {
      name: "The Sacred Grove",
      address: "789 Unity Blvd, Malibu, CA 90265",
      mapUrl: "https://maps.google.com/?q=The+Sacred+Grove",
    },
    description: "Witness the sacred vows as we begin our journey together.",
    rsvpDeadline: "October 15, 2024",
    imageUrl: "/assets/images/about_me.jpg",
  },
  {
    slug: "reception",
    name: "Wedding Reception",
    date: "October 26, 2024",
    time: "7:00 PM onwards",
    venue: {
      name: "Oceanview Hall",
      address: "101 Coastal Dr, Santa Monica, CA 90401",
      mapUrl: "https://maps.google.com/?q=Oceanview+Hall",
    },
    description: "Join us for a grand celebration with dinner and dancing.",
    rsvpDeadline: "October 15, 2024",
    imageUrl: "/assets/images/about_me.jpg",
  },
];
